import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const IosIMessage = ({ height = 187.5, width = 187.5, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 187.5 187.5" {...props}>
    <linearGradient
      id="rect826_00000075876563843838826500000012060853015310139307_"
      gradientUnits="userSpaceOnUse"
      x1="-580.0902"
      y1="267.6309"
      x2="-580.0902"
      y2="322.1532"
      gradientTransform="matrix(2.7839 0 0 -2.7839 1708.6543 920.1071)"
    >
      <stop offset="0" stopColor="#0CBD2A" />
      <stop offset="1" stopColor="#5BF675" />
    </linearGradient>
    <path
      d="M41.295,0h104.911C169.012,0,187.5,18.488,187.5,41.295v104.911c0,22.806-18.488,41.295-41.295,41.295H41.295C18.488,187.5,0,169.012,0,146.205V41.295C0,18.488,18.488,0,41.295,0z"
      fill="url(#rect826_00000075876563843838826500000012060853015310139307_)"
    />
    <path
      d="M93.75,32.458c-38.008,0-68.82,25.664-68.82,57.322c0.034,20.114,12.722,38.742,33.434,49.084c-2.712,6.071-6.779,11.765-12.034,16.844c10.189-1.789,19.754-5.546,27.951-10.98c6.32,1.564,12.876,2.364,19.469,2.375c38.008,0,68.82-25.664,68.82-57.322C162.57,58.122,131.758,32.458,93.75,32.458L93.75,32.458z"
      fill="#FFFFFF"
    />
  </SvgIcon>
);
